import {SetGetGroupJackpot} from './thunk/setGetGroupJackpot';
import {SetGetGroups} from './thunk/setGetGroups';
import {SetGetJackpotList} from './thunk/setGetJackpotList';
import {SetGetJackpotView} from './thunk/setGetJackpotView';
import {SetPostCreateJackpot} from './thunk/setPostCreateJackpot';
import {SetPostJackpotIssue} from './thunk/setPostJackpotIssue';
import {SetPostNullify} from './thunk/setPostNullify';
import {SetPostUpdateGive} from './thunk/setPostUpdateGive';
import {SetPostUpdateJackpot} from './thunk/setPostUpdateJackpot';
import {SetPostUpdateVisible} from './thunk/setPostUpdateVisible';

export const Thunks = {
    SetGetGroupJackpot,
    SetGetGroups,
    SetGetJackpotList,
    SetGetJackpotView,
    SetPostCreateJackpot,
    SetPostJackpotIssue,
    SetPostNullify,
    SetPostUpdateGive,
    SetPostUpdateJackpot,
    SetPostUpdateVisible
}